// Module
var code = `<div class="instrumentLookupDropDownForm">
    <div class="header_lookupDropDownForm">
        <terceraTextBox name="textBox" additionalClass="textBox_lookupDropDownForm" isMaterialDesign="false" svgIcon="search"/>
        <div class="filter-container">
            <terceraMultiComboBox name="exchanges" additionalClass="multiComboBox_lookupDropDownForm" showLastValue="true" />
            <terceraMultiComboBox visible="{{!isOptionMasterMode}}" name="types" additionalClass="multiComboBox_lookupDropDownForm" showLastValue="true" />
        </div>
    </div>

    <div class="body_lookupDropDownForm">
        <terceraQuickTree name="quickTree" boldRootNode="true" />
    </div>

    <div class="footer_lookupDropDownForm">
        <div class="collapseBtnContainer">
            <terceraButton name="collapseAllIcon" SVG="true" on-componentClick="@this.collapseAll()" terceraButtonStyle="instrument-lookup-btn"/>
            <terceraButton name="expandExchangesIcon" SVG="true" on-componentClick="@this.clickExchange(true)" terceraButtonStyle="instrument-lookup-btn"/>
            <terceraButton name="expandTypesIcon" SVG="true" on-componentClick="@this.clickExchange(false)" terceraButtonStyle="instrument-lookup-btn"/>
        </div>
        {{#if .isShowFooterBtn}}
        <div class="addCancelBtnContainer">
            <terceraButton name="addBtn" terceraButtonStyle="js-button-ok style-width-100" on-componentClick="@this.onAddBtnClicked(true)" enabled="{{.enabledAddBtn}}" text="{{.addBtnText}}" />
            <terceraButton terceraButtonStyle="js-button-gray25 style-width-100" on-componentClick="@this.close()" text="{{.cancelBtnText}}" />
        </div>
        {{/if}}
    </div>
</div>`;
// Exports
export default code;